import { render, staticRenderFns } from "./passengerEditModal.vue?vue&type=template&id=34a704e4&scoped=true&"
import script from "./passengerEditModal.vue?vue&type=script&lang=ts&"
export * from "./passengerEditModal.vue?vue&type=script&lang=ts&"
import style0 from "./passengerEditModal.vue?vue&type=style&index=0&id=34a704e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a704e4",
  null
  
)

export default component.exports